export default __webpack_public_path__ + "static/media/farmacia-hover.99b2824f.svg";